// Formatting helpers ported from iventas-analytics/apps/analytics-dashboard
// src/lib/utils.ts, adapted for plain JS usage in the host app.

export function formatNumber(num) {
  if (num === null || num === undefined) return "0";
  const value = Number(num);
  if (!Number.isFinite(value)) return "0";
  // Show exact values: integers as-is, floats rounded to 2 decimal places.
  return Number.isInteger(value) ? value.toString() : value.toFixed(2);
}

export function formatPercentage(value) {
  return `${(Number(value) || 0).toFixed(1)}%`;
}

export function formatDate(date) {
  return new Date(date).toLocaleDateString("es-MX", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(date) {
  return new Date(date).toLocaleString("es-MX", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTime(seconds) {
  const value = Number(seconds) || 0;
  if (value < 60) {
    return `${Math.round(value)}s`;
  }
  if (value < 3600) {
    const minutes = Math.floor(value / 60);
    const remainingSeconds = Math.round(value % 60);
    return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
  }
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
}

export function calculateTrend(current, previous) {
  if (!previous) return current > 0 ? 100 : 0;
  return ((current - previous) / previous) * 100;
}

export function formatTrend(trend) {
  if (!Number.isFinite(trend)) return "0.0%";
  const sign = trend >= 0 ? "+" : "";
  return `${sign}${trend.toFixed(1)}%`;
}

export function truncate(text, maxLength = 30) {
  if (!text) return "";
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}
